import { render } from "./Persona_MedioPers.vue?vue&type=template&id=f164a4dc"
import script from "./Persona_MedioPers.vue?vue&type=script&lang=js"
export * from "./Persona_MedioPers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__